module.exports = __webpack_public_path__ + "static/media/endless-logo.ee8631c3.png";